import React, { Fragment } from "react";
import ContainerDimensions from "react-container-dimensions";
import NewStacked from "../../../d3Components/StackedArea/NewStackedArea/newStacked";
import Status from "./Status";
import Helper from "./Helper";

const growth = ({ yrs, i }) => {
  var p = 10000;
  var x = p * Math.pow(1 + i, yrs);
  return <div className="font-22">{Helper.moneyFormat({ number: x })}</div>;
};

const CardInnerContent = ({
  Data,
  ChartID,
  CardID,
  display,
  footer,
  border,
}) => {
  return (
    <div
      className={
        border === false
          ? ""
          : Data.type === "LIVE"
          ? "cardMainBody-live"
          : "cardMainBody"
      }
      id={CardID}
      style={{ display: display }}
    >
      <div className="cardHeading">
        {Data.scn_status === "SUBMITTED" ? (
          <Status type="submitted" />
        ) : Data.scn_status === "PROCESSING" ? (
          <Status type="processing" />
        ) : Data.scn_status === "ERROR" ? (
          <Status type="error" />
        ) : null}
        <div className="u-Line z1">Since Inception</div>
      </div>
      <div className="cardContent textCenter">
        <ContainerDimensions>
          {({ width }) => (
            <Fragment>
              {width > 0 &&
              Data.bm_annualized_return &&
              Data.fund_annualized_return ? (
                <NewStacked
                  chartId={ChartID}
                  Data2={Helper.StackedData2({
                    bm_annualized_return: Data.bm_annualized_return,
                    fund_annualized_return: Data.fund_annualized_return,
                  })}
                  Data1={Helper.StackdData({
                    bm_annualized_return: Data.bm_annualized_return,
                    fund_annualized_return: Data.fund_annualized_return,
                  })}
                  width={width - 2}
                  height={150}
                />
              ) : null}
            </Fragment>
          )}
        </ContainerDimensions>
        <div className="Content1 pb-10 ">
          <div className="z1">
            <div className="font-22">
              <Fragment>{`${(Data.fund_annualized_return * 100).toFixed(
                2
              )}%`}</Fragment>
            </div>
            <div className="z1">Portfolio</div>
          </div>
          <div className="z1">
            <div className="font-22">
              &nbsp;
              <Fragment>
                {`${(Data.bm_annualized_return * 100).toFixed(2)}%`}
              </Fragment>
            </div>
            <div className="z1">
              benchmark <sup>*</sup>
            </div>
          </div>
        </div>
        <div className="u-Line z1">Hypothetical growth</div>
        <div className="GrowthContent z1">
          <div className="z1">
            {/* change to fund_annualized to use Math.round */}
            <div>5Y</div>
            {growth({ yrs: 5, i: Data.fund_annualized_return })}
          </div>
          <div className="z1">
            <div>10Y</div>
            {growth({ yrs: 10, i: Data.fund_annualized_return })}
          </div>
          <div className="z1">
            <div>20Y</div>
            {growth({ yrs: 20, i: Data.fund_annualized_return })}
          </div>
        </div>
        {Data.benchmark_name ? (
          <div className="Btm_txt z1">*{Data.benchmark_name}</div>
        ) : null}
      </div>
      {footer !== false ? (
        <div className="cardFooter">
          <i className="fa fa-plus-square" aria-hidden="true" />
          View details
        </div>
      ) : null}
    </div>
  );
};

export default CardInnerContent;



// WEBPACK FOOTER //
// ./src/components/myPortfolios/cards/helper/CardInnerContent.jsx